module.exports = __webpack_public_path__ + "img/ico_new_4.d2d6d7eb.svg";